module.exports = __webpack_public_path__ + "static/media/appLab_add_item.13b34b08.png";